/**
 * Format a value as currency with 2 decimal places
 */
export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '—';
  const formatted = new Intl.NumberFormat('en-CA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(value));
  return value < 0 ? `($${formatted})` : `$${formatted}`;
};

/**
 * Format a per-unit rate (e.g. admin fee $/kWh, or a percentage expressed as a decimal) with
 * 4 decimal places — unlike formatCurrency's fixed 2 decimals, small rates like 0.003 need the
 * extra precision or they'd round away to $0.00.
 */
export const formatRate = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '—';
  const formatted = new Intl.NumberFormat('en-CA', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(Math.abs(value));
  return value < 0 ? `($${formatted})` : `$${formatted}`;
};

/**
 * Format a value as a whole number with no decimal places
 */
export const formatWholeNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('en-CA', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};
